import React from 'react';

export function NewsCardSkeleton() {
  return (
    <div className="bg-card rounded-2xl overflow-hidden border border-border animate-pulse">
      <div className="skeleton-pulse h-44 w-full" />
      <div className="p-3 space-y-2">
        <div className="flex gap-2">
          <div className="skeleton-pulse h-4 w-16 rounded-full" />
          <div className="skeleton-pulse h-4 w-12 rounded-full" />
        </div>
        <div className="skeleton-pulse h-4 w-full rounded" />
        <div className="skeleton-pulse h-4 w-4/5 rounded" />
        <div className="skeleton-pulse h-4 w-3/5 rounded" />
        <div className="skeleton-pulse h-3 w-2/5 rounded mt-2" />
      </div>
    </div>
  );
}

export function HeroCardSkeleton() {
  return (
    <div className="skeleton-pulse rounded-2xl h-72 sm:h-96 w-full" />
  );
}

export function CategoryCardSkeleton() {
  return (
    <div className="bg-card rounded-2xl border border-border p-4 animate-pulse">
      <div className="skeleton-pulse h-10 w-10 rounded-xl mb-3" />
      <div className="skeleton-pulse h-4 w-3/4 rounded mb-1" />
      <div className="skeleton-pulse h-3 w-1/2 rounded" />
    </div>
  );
}

export function TickerSkeleton() {
  return (
    <div className="skeleton-pulse h-9 w-full" />
  );
}